var __default__ = {root:'m_4addd315',control:'m_326d024a',dots:'m_4ad7767d'};
export default __default__;